import { getAudioNodeConnections } from './get-audio-node-connections';
export const getAudioNodeRenderer = (audioNode) => {
    const audioNodeConnections = getAudioNodeConnections(audioNode);
    if (audioNodeConnections.renderer === null) {
        throw new Error('Missing the renderer of the given AudioNode in the audio graph.');
    }
    return audioNodeConnections.renderer;
};
//# sourceMappingURL=/build/es2018/helpers/get-audio-node-renderer.js.map